import { HotelEntryTypeEnum, VrCrossSellEntryProperties } from "redmond";

type CrossSellFeedPlacement = NonNullable<
  VrCrossSellEntryProperties["feed_placement"]
>;

const CROSS_SELL_FEED_PLACEMENT: Record<string, CrossSellFeedPlacement> = {
  [HotelEntryTypeEnum.HOMEPAGE_VIEW_ALL]: "homepage",
  [HotelEntryTypeEnum.HOMEPAGE_CARD]: "homepage",
  [HotelEntryTypeEnum.MY_TRIPS_VIEW_ALL]: "my_trips",
  [HotelEntryTypeEnum.MY_TRIPS_CARD]: "my_trips",
  [HotelEntryTypeEnum.FLIGHT_CONFIRMATION_VIEW_ALL]: "booking_confirmation",
  [HotelEntryTypeEnum.FLIGHT_CONFIRMATION_CARD]: "booking_confirmation",
};

const getVrCrossSellProperties = (
  entryPoint: string | undefined
): VrCrossSellEntryProperties => {
  const feedPlacement =
    entryPoint != null ? CROSS_SELL_FEED_PLACEMENT[entryPoint] : undefined;
  if (feedPlacement == null) return {};

  return {
    entry_type: "cross_sell",
    feed_placement: feedPlacement,
    // VR is only cross-sold off flight bookings today, matching the hotel funnel.
    origin_product_type: "air",
  };
};

export default getVrCrossSellProperties;
